import * as React from "react";
export const LogoutIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={30} height={30} viewBox="0 0 30 30" {...props}>
      <path
        d="M26.318,12.094A14.224,14.224,0,1,0,40.542,26.318,14.224,14.224,0,0,0,26.318,12.094Z"
        transform="translate(-11.318 -11.318)"
        fill="transparent"
      />
      <path
        d="M23.063,38.063a15,15,0,1,1,15-15A15.011,15.011,0,0,1,23.063,38.063Zm0-28.448A13.448,13.448,0,1,0,36.511,23.063,13.455,13.455,0,0,0,23.063,9.615Z"
        transform="translate(-8.063 -8.063)"
        fill="#01579B"
      />
      <path
        d="M50.192,63.082a8.535,8.535,0,0,1-4.268-15.928A.776.776,0,1,1,46.7,48.5a6.984,6.984,0,1,0,6.984,0,.776.776,0,1,1,.776-1.345,8.535,8.535,0,0,1-4.268,15.928Z"
        transform="translate(-35.192 -39.549)"
        fill="#01579B"
      />
      <path
        d="M82.744,41.66a.762.762,0,0,1-.776-.776V35.713a.776.776,0,1,1,1.551,0v5.171A.762.762,0,0,1,82.744,41.66Z"
        transform="translate(-67.744 -29.765)"
        fill="#01579B"
      />
    </svg>
  );
};
